import React from "react"
import { useHistory } from "react-router-dom"
import { useRecoilState } from "recoil"
import { useSnackbar } from "notistack"
// import { Formik, Form } from "formik"
// import * as Yup from "yup"
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"

import StepButtons from "../components/StepButtons"
import { createAssociation } from "../libs/manageAccounts"
import currentAssociation from "../store/currentAssociation"
import currentUser from "../store/currentUser"
import onboardingProgress from "../store/onboardingProgress"

export default function BillingInfo() {
  const [isLoading, setIsLoading] = React.useState(false)
  const [association, setAssociation] = useRecoilState(currentAssociation)
  const [user, setUser] = useRecoilState(currentUser)
  const [progress, setProgress] = useRecoilState(onboardingProgress)
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()

  const stripe = useStripe()
  const elements = useElements()

  function validateForm() {
    return true
  }

  const setupAccount = async () => {
    setIsLoading(true)
    try {
      const associationId = await createAssociation(progress.association, progress.user)

      setAssociation({
        ...association,
        ...progress.association,
        id: associationId,
      })

      setUser({
        ...user,
        ...progress.user,
      })

      setIsLoading(false)
      return history.push("/0")
    } catch (error) {
      console.log("error", error)
      enqueueSnackbar("Could not set up account", {
        variant: "error",
      })
      setIsLoading(false)
    }
  }

  const handleSubmit = async (event) => {
    setIsLoading(true)
    enqueueSnackbar("Processing payment")
    // Block native form submission.
    event.preventDefault()

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement)

    // Use your card Element with other Stripe.js APIs
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    })

    // setIsLoading(false)
    if (error) {
      console.log("error", error)
      enqueueSnackbar(`There was a problem processing payment`, {
        variant: "error",
      })
    } else {
      enqueueSnackbar("Payment successful!", {
        variant: "success",
      })
      setProgress({
        ...progress,
        association: {
          ...progress.association,
          cardId: paymentMethod.id,
        },
      })
      setupAccount()
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography>Your card will be charged $9.95 /year</Typography>
        </Grid>
        <Grid item xs={12}>
          <CardElement
            options={{
              style: {
                root: {
                  borderColor: "#858585",
                  borderSize: "1px !important",
                  borderStyle: "solid !important",
                  borderRadius: "4px",
                  fontSize: "16px",
                  color: "#424770",
                  "::placeholder": {
                    color: "#aab7c4",
                  },
                },
                invalid: {
                  borderColor: "#f44336",
                  color: "#f44336",
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <StepButtons
            disableNext={!validateForm()}
            isLoading={isLoading}
            nextText="Create Account"
          />
        </Grid>
      </Grid>
    </form>
  )
}
